<div class="mobile_version-backbutton">
    <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""></span>Media</a>
</div>
<div class="col-md-12 mainPageTitle">
    <div class="pageTitle">
        <h2>Media</h2>
        <p>Tennis Premier League has featured on prominent news platforms like The Times of<br>
            India, India Tv News, Deccan Chronicle, ABP News, News 18, Times Now News, India Today, Aaj Tak,<br>
            Hindustan Times, Bombay Times, Mid-day, and many more…</p>
    </div>
</div>
<section class="news-section" id="newsSection">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sectionHeading">
                    <div class="left-heading">
                        <h2>News Updates </h2>
                    </div>
                    <div class="right-heading">
                    </div>
                </div>
                <div class="slider-main">
                    <swiper class="swiper-container  " fxFlex="auto" [config]="newsSlider">
                        <div *ngFor="let news of NewsArticals" class="swiper-slide  ">
                            <div class="main-slider">
                                <div class="news-image">
                                    <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'" [lazyLoad]="news.src"
                                        alt="">
                                </div>
                                <div class="main-top">
                                    <div class="meidaleft">
                                        <img src="../../../assets/images/aboutUs/newsImage.png" alt="">
                                        <div class="textName">
                                            <span>{{ news.channelName }}</span>
                                        </div>
                                    </div>
                                    <div class="meidaright">
                                        {{ news.createdAt | date:'dd MMM yyyy' }}
                                    </div>
                                </div>
                                <div class="main-title">
                                    <h4> {{news.heading}} </h4>
                                    <div class="bttuon" routerLink="{{news.url}}">
                                        <img src="../../../assets/images/aboutUs/buttonGo.svg" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="portfolio" class="portfolio heighlights-section">
    <div class="container" data-aos="fade-up">
        <p-tabView>
            <p-tabPanel header="Print Articles">
                <section id="photos" class="pt-0" style="padding-top: 0px!important;">
                    <img *ngFor="let item of printArticles" [src]="item.src" (click)="openHightlightImage(item)" alt="">
                </section>
            </p-tabPanel>
            <p-tabPanel header="Digital Articles">
                <!-- <div class="not-found-section w-100">
                    <div class="col-md-12 not-found-body">
                        <img src="assets/img/logo/not-found.gif" alt="">
                        <h4> Coming Soon </h4>
                    </div>
                </div> -->
                <section id="photos">
                    <a *ngFor="let item of DigitalArticles" [href]="item.link" target="_blank">

                        <button>
                            {{ item.channelName }}
                        </button>

                        <img [src]="item.src" alt="">

                    </a>
                </section>
            </p-tabPanel>
            <p-tabPanel header="Digital Media">
                <div class="not-found-section w-100" *ngIf="!DigitalMedia?.length">
                    <div class="col-md-12 not-found-body">
                        <img src="assets/img/logo/not-found.gif" alt="">
                        <h4> Coming Soon </h4>
                    </div>
                </div>
                <section id="photos">
                    <a *ngFor="let item of DigitalMedia" [href]="item.link || 'javascript:void(0)'" target="_blank">

                        <button>
                            {{ item.channelName }}
                        </button>

                        <img [src]="item.src" alt="">

                    </a>
                </section>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
<p-galleria [(value)]="printArticles" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-item>
        <img [src]="showHighlightImg" style="width: 100%; display: block;" />
    </ng-template>